import { Link } from 'react-router-dom'
import logoImg from '../assets/logo.jpg'

export function Logo() {
  return <Link to="/" className="logo" aria-label="MiXer AI 首页">
    <span className="logo-mark"><img src={logoImg} alt="" aria-hidden="true"/></span>
    <span>MiXer AI <b>开发者平台</b><i className="version-badge" aria-label="版本 2.1 预览版">2.1<small>preview</small></i></span>
  </Link>
}
